<template>
  <div>
    <v-dialog v-model="visible" width="90%" persistent transition="dialog-bottom-transition">
      <v-card class="rounded-xl border-light" outlined elevation="0">
        <!-- Header del Modal -->
        <v-card-title class="d-flex align-center justify-space-between py-3 px-5 border-light-bottom">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-truck-delivery-outline</v-icon>
            <span class="text-h6 font-weight-bold grey--text text--darken-4">
              Atención de Transferencia: {{ transfer ? transfer.WtrDocumentNumber : '' }}
            </span>
          </div>
          <v-btn icon small @click="close" :disabled="processing">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="py-4 px-5">
          <v-row>
            <!-- COLUMNA IZQUIERDA: Detalle de Transferencia y Materiales (9 cols) -->
            <v-col cols="12" lg="9">
              <!-- 1. Datos Resumen de la Solicitud -->
              <v-card class="mb-4 pa-4 rounded-lg bg-light border-light" outlined elevation="0">
                <v-row dense>
                  <v-col cols="12" sm="3">
                    <span class="text-caption grey--text text--darken-2">Área Solicitante:</span>
                    <div class="font-weight-bold grey--text text--darken-4">
                      {{ transfer ? transfer.AreName : '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <span class="text-caption grey--text text--darken-2">Fecha de Solicitud:</span>
                    <div class="font-weight-bold grey--text text--darken-4">
                      {{ transfer ? formatDate(transfer.WtrDate) : '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <span class="text-caption grey--text text--darken-2">Turno:</span>
                    <div class="font-weight-bold grey--text text--darken-4">
                      {{ transfer ? transfer.TypeShiftName : '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <span class="text-caption grey--text text--darken-2">Encargado Producción:</span>
                    <div class="font-weight-bold grey--text text--darken-4">
                      {{ transfer ? transfer.WtrManager : '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" class="mt-2" v-if="transfer && transfer.WtrObservation">
                    <span class="text-caption grey--text text--darken-2">Observación Solicitud:</span>
                    <div class="font-italic grey--text text--darken-3">
                      {{ transfer.WtrObservation }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Grilla de Materiales y Edición de Cantidad a Despachar -->
              <div class="d-flex align-center justify-space-between mb-2">
                <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
                  Materiales a Transferir
                </span>
                <span class="text-caption grey--text text--darken-2">
                  Verifique la cantidad física despachada y el almacén destino antes de enviar a SAP
                </span>
              </div>

              <v-data-table
                :headers="headers"
                :items="details"
                :loading="loadingDetail"
                dense
                hide-default-footer
                :items-per-page="-1"
                class="border-light rounded-lg"
                no-data-text="No hay materiales cargados"
              >
                <template v-slot:[`item.WtdQuantityRequested`]="{ item }">
                  {{ Number(item.WtdQuantityRequested).toFixed(2) }}
                </template>
                <template v-slot:[`item.WtdQuantityServed`]="{ item }">
                  <div style="max-width: 140px;" class="py-1">
                    <s-text
                      v-model.number="item.WtdQuantityServed"
                      type="number"
                      dense
                      @blur="validateQuantity(item)"
                    />
                  </div>
                </template>
                <template v-slot:[`item.diff`]="{ item }">
                  <span
                    :class="
                      Number(item.WtdQuantityServed) < Number(item.WtdQuantityRequested)
                        ? 'warning--text font-weight-bold'
                        : 'grey--text'
                    "
                  >
                    {{ (Number(item.WtdQuantityServed || 0) - Number(item.WtdQuantityRequested)).toFixed(2) }}
                  </span>
                </template>
                <template v-slot:[`item.FromWhsCode`]="{ item }">
                  <span>{{ getWarehouseName(item.FromWhsCode) }}</span>
                </template>
                <template v-slot:[`item.ToWhsCode`]="{ item }">
                  <div style="min-width: 160px;" class="py-1">
                    <s-select
                      :items="warehouses"
                      item-text="WhsName"
                      item-value="WhsCode"
                      v-model="item.ToWhsCode"
                      dense
                    />
                  </div>
                </template>
              </v-data-table>
            </v-col>

            <!-- COLUMNA DERECHA: Tarjeta Datos de Usuario (3 cols) -->
            <v-col cols="12" lg="3">
              <v-card class="rounded-lg border-light" outlined elevation="0">
                <v-container class="pa-3">
                  <h4 class="text-center font-weight-bold grey--text text--darken-4 mb-3">
                    Datos de Usuario
                  </h4>

                  <v-row dense>
                    <v-col cols="12">
                      <s-text label="Despachado por" v-model="userInfo.NtpFullName" readonly />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <s-text label="Registrado por" v-model="userInfo.NtpFullName" readonly />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <s-toolbar-person
                        v-model="person"
                        @returnPerson="returnPerson($event)"
                        addBirthDate
                        addTypeSex
                        noEdit
                        autofocus
                      />
                      <s-text label="Recogido por" v-model="getPerson.NtpFullName" readonly />
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <s-textarea label="Comentarios" v-model="requestComments" :rows="3"></s-textarea>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12">
                      <s-text label="Glosa de Asiento Contable" v-model="requestAccount" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Acciones del Modal -->
        <v-card-actions class="py-3 px-5">
          <v-btn
            color="error"
            text
            class="text-none rounded-lg"
            :disabled="processing"
            @click="openRejectModal"
          >
            <v-icon left small>mdi-close-circle-outline</v-icon>
            Rechazar Solicitud
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn text class="text-none rounded-lg" @click="close" :disabled="processing">
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            class="text-none rounded-lg font-weight-bold px-5"
            elevation="0"
            :loading="processing"
            :disabled="!isReadyToTransfer"
            @click="confirmTransfer"
          >
            <v-icon left small>mdi-cloud-upload</v-icon>
            Ejecutar Transferencia a SAP
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal para Confirmar Rechazo con Motivo -->
    <v-dialog v-model="dialogReject" max-width="500" persistent>
      <v-card class="rounded-xl border-light" outlined elevation="0">
        <v-card-title class="py-3 px-5 border-light-bottom">
          <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
          <span class="text-subtitle-1 font-weight-bold grey--text text--darken-4">
            Rechazar Solicitud de Transferencia
          </span>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-4 px-5">
          <p class="text-body-2 grey--text text--darken-3 mb-3">
            Indique el motivo por el cual se rechaza esta solicitud:
          </p>
          <s-text
            label="Motivo del Rechazo *"
            v-model="reasonRejected"
            placeholder="Ejemplo: Falta de stock, código errado, etc."
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3 px-5">
          <v-spacer></v-spacer>
          <v-btn text class="text-none rounded-lg" @click="dialogReject = false" :disabled="rejecting">
            Cancelar
          </v-btn>
          <v-btn
            color="error"
            class="text-none rounded-lg font-weight-bold px-4"
            elevation="0"
            :loading="rejecting"
            :disabled="!reasonRejected || reasonRejected.trim().length < 3"
            @click="executeReject"
          >
            Confirmar Rechazo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SSelect from "@/components/Utils/SSelect.vue";
import SText from "@/components/Utils/SText.vue";
import STextarea from "@/components/Utils/sTextarea.vue";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson.vue";
import _sWarehouseTransfer from "@/services/Logistics/WarehouseTransferService";

export default {
  name: "WarehouseTransferAttentionModal",
  components: {
    SSelect,
    SText,
    STextarea,
    sToolbarPerson,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    transfer: {
      type: Object,
      default: null,
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      processing: false,
      loadingDetail: false,
      rejecting: false,
      dialogReject: false,
      reasonRejected: "",
      fromWhsCode: "01", // Origen por defecto Almacén General
      commentsAttention: "",
      userInfo: {},
      person: null,
      getPerson: {
        PrsDocumentNumber: "",
        NtpFullName: null,
        NtpID: null,
      },
      requestComments: "",
      requestAccount: "",
      details: [],
      headers: [
        { text: "N°", value: "WtdNumLine", width: 60, align: "center" },
        { text: "Código", value: "ArtCode", width: 120 },
        { text: "Descripción del Material", value: "WtdDescription" },
        { text: "U.M.", value: "UnitMeasurement", width: 80, align: "center" },
        { text: "Cant. Solicitada", value: "WtdQuantityRequested", width: 130, align: "right" },
        { text: "Cant. a Despachar *", value: "WtdQuantityServed", width: 150, align: "right" },
        { text: "Diferencia", value: "diff", width: 100, align: "right" },
        { text: "Almacén Origen", value: "FromWhsCode", width: 160 },
        { text: "Almacén Destino *", value: "ToWhsCode", width: 190 },
      ],
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    isReadyToTransfer() {
      if (this.details.length === 0) return false;
      return this.details.every(
        (d) => Number(d.WtdQuantityServed) >= 0 && Number(d.WtdQuantityServed) <= Number(d.WtdQuantityRequested) * 2 && d.ToWhsCode
      ) && this.details.some((d) => Number(d.WtdQuantityServed) > 0);
    },
  },
  watch: {
    value(val) {
      if (val && this.transfer) {
        this.initializeUser();
        this.loadDetails();
      }
    },
    warehouses: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0 && !this.fromWhsCode) {
          this.fromWhsCode = val[0].WhsCode;
        }
      },
    },
  },
  methods: {
    initializeUser() {
      this.userInfo = this.$fun.getUserInfo() || {};
      this.person = null;
      this.getPerson = {
        PrsDocumentNumber: "",
        NtpFullName: null,
        NtpID: null,
      };
      this.requestComments = "";
      this.requestAccount = "";
    },
    returnPerson(person) {
      if (person != null) {
        this.getPerson.NtpFullName = person.NtpFullName;
        this.getPerson.NtpID = person.NtpID;
        this.getPerson.TypePersonDocument = person.TypePersonDocument;
        this.getPerson.PrsDocumentNumber = person.PrsDocumentNumber;
      }
    },
    loadDetails() {
      this.loadingDetail = true;
      this.requestComments = `Transferencia para área ${this.transfer.AreName} - Solicitud ${this.transfer.WtrDocumentNumber}`;
      this.requestAccount = `Transf. Almacen ${this.transfer.WtrDocumentNumber}`;
      _sWarehouseTransfer
        .detail({ WtrID: this.transfer.WtrID }, this.$fun.getUserID())
        .then((resp) => {
          this.details = (resp.data || []).map((d) => ({
            ...d,
            WtdQuantityServed: d.WtdQuantityServed != null ? d.WtdQuantityServed : d.WtdQuantityRequested,
            FromWhsCode: d.FromWhsCode || this.fromWhsCode || "01",
            ToWhsCode: d.ToWhsCode || this.transfer.ToWhsCode || "01",
          }));
          this.loadingDetail = false;
        })
        .catch(() => {
          this.loadingDetail = false;
        });
    },
    applyWarehouseToLines(whs) {
      if (this.details) {
        this.details.forEach((d) => {
          d.FromWhsCode = whs;
        });
      }
    },
    validateQuantity(item) {
      if (item.WtdQuantityServed == null || isNaN(item.WtdQuantityServed) || Number(item.WtdQuantityServed) < 0) {
        item.WtdQuantityServed = item.WtdQuantityRequested;
      }
      if (Number(item.WtdQuantityServed) > Number(item.WtdQuantityRequested)) {
        this.$fun.alert(`La cantidad despachada no puede ser mayor a la solicitada (${item.WtdQuantityRequested}).`, "warning");
        item.WtdQuantityServed = item.WtdQuantityRequested;
      }
    },
    isValidate() {
      const sapUser = this.$fun.getUserSAPInfo();
      if (!sapUser || !sapUser.UsrID) {
        this.$fun.alert("Credenciales SAP incorrectas o no configuradas para este usuario.", "warning");
        return false;
      }

      const hasInvalidDestination = this.details.some((d) => !d.ToWhsCode);
      if (hasInvalidDestination) {
        this.$fun.alert("Debe seleccionar el almacén destino para cada material en la grilla.", "warning");
        return false;
      }

      if (!this.getPerson.NtpFullName) {
        this.$fun.alert("Debe registrar la persona que recoge el requerimiento.", "warning");
        return false;
      }

      if (!this.requestComments || this.requestComments.trim().length < 5) {
        this.$fun.alert("Debe ingresar un comentario de atención con al menos 5 caracteres.", "warning");
        return false;
      }

      if (!this.requestAccount || this.requestAccount.trim().length === 0) {
        this.$fun.alert("Debe registrar la Glosa de Asiento Contable.", "warning");
        return false;
      }

      return true;
    },
    confirmTransfer() {
      if (!this.isValidate()) {
        return;
      }

      this.$fun
        .alert(
          "¿Está seguro de ejecutar la transferencia de estos materiales a SAP?",
          "question"
        )
        .then((res) => {
          if (res.value) {
            this.executeTransfer();
          }
        });
    },
    executeTransfer() {
      this.processing = true;

      const originWhs = this.fromWhsCode || this.transfer.FromWhsCode || (this.warehouses.length > 0 ? this.warehouses[0].WhsCode : "01");
      const defaultToWhs = this.details[0]?.ToWhsCode || this.transfer.ToWhsCode || "01";

      const payload = {
        WtrID: this.transfer.WtrID,
        WtrDocumentNumber: this.transfer.WtrDocumentNumber,
        FromWhsCode: originWhs,
        ToWhsCode: defaultToWhs,
        WtrCommentsAttention: this.requestComments,
        RequestDispatchedSAP: this.userInfo.PrsDocumentNumber,
        RequestRegisteredSAP: this.userInfo.PrsDocumentNumber,
        RequestCollectedSAP: this.getPerson.PrsDocumentNumber,
        WtrCollectedBy: this.getPerson.NtpFullName,
        RequestComments: this.requestComments,
        RequestAccount: this.requestAccount,
        NtpDispatchedID: this.userInfo.NtpID,
        NtpCollectedID: this.getPerson.NtpID,
        Details: this.details.map((d) => ({
          WtdID: d.WtdID,
          WtrID: d.WtrID,
          WtdNumLine: d.WtdNumLine,
          ArtCode: d.ArtCode,
          WtdDescription: d.WtdDescription,
          UnitMeasurement: d.UnitMeasurement,
          WtdQuantityRequested: d.WtdQuantityRequested,
          WtdQuantityServed: Number(d.WtdQuantityServed),
          FromWhsCode: d.FromWhsCode || originWhs,
          ToWhsCode: d.ToWhsCode,
        })),
      };

      const sapUser = this.$fun.getUserSAPInfo();

      _sWarehouseTransfer
        .attend(payload, sapUser.UsrID)
        .then((resp) => {
          this.processing = false;
          const docEntry = resp.data?.DocEntry;
          this.$fun.alert(
            `Transferencia ejecutada con éxito en SAP. DocEntry generado: ${docEntry || 'OK'}`,
            "success"
          );
          this.$emit("attended");
          this.close();
        })
        .catch((err) => {
          this.processing = false;
          const msg = err.response?.data?.Message || err.message || "Error al enviar la transferencia a SAP.";
          this.$fun.alert(msg, "error");
        });
    },
    openRejectModal() {
      this.reasonRejected = "";
      this.dialogReject = true;
    },
    executeReject() {
      this.rejecting = true;
      const payload = {
        WtrID: this.transfer.WtrID,
        WtrReasonRejected: this.reasonRejected,
      };

      _sWarehouseTransfer
        .reject(payload, this.$fun.getUserID())
        .then(() => {
          this.rejecting = false;
          this.dialogReject = false;
          this.$fun.alert("Solicitud rechazada.", "success");
          this.$emit("attended");
          this.close();
        })
        .catch((err) => {
          this.rejecting = false;
          const msg = err.response?.data?.Message || err.message || "Error al rechazar la solicitud.";
          this.$fun.alert(msg, "error");
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return dateStr.substring(0, 10);
    },
    getWarehouseName(code) {
      if (!code) return "-";
      const strCode = String(code).trim();
      const wh = this.warehouses.find(
        (w) =>
          String(w.WhsCode).trim() === strCode ||
          String(w.WhsCode).trim().padStart(2, "0") === strCode.padStart(2, "0")
      );
      return wh ? `${wh.WhsCode} - ${wh.WhsName}` : code;
    },
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>

